import script from "./AutoDisconnectedPage.vue?vue&type=script&setup=true&lang=js"
export * from "./AutoDisconnectedPage.vue?vue&type=script&setup=true&lang=js"

import "./AutoDisconnectedPage.vue?vue&type=style&index=0&id=d534650e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d534650e"]])

export default __exports__